import RecoverWrapper from './RecoverWrapper.jsx';
export default RecoverWrapper;
